import { Button, Popconfirm, Space, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { selectUser } from '../../../../auth/states/userSlice';
import { IPermission } from '../../../../common/types/commonTypes';
import { useDeleteAirticketRefundMutation } from '../../Api/Endpoints/AirTicketRefundEndpoints';
import {
  IAirTicketRefundDataType,
  IRefundDeleteRestoreBody,
} from '../../RefundTypes/RefundTypes';

export const AirTicketViewUtils = ({
  permission,
  pagination,
  checkButtonState,
}: {
  permission?: IPermission;
  checkButtonState?: boolean;
  pagination: {
    current: number;
    pageSize: number;
  };
}): ColumnsType<IAirTicketRefundDataType> => {
  const navigate = useNavigate();
  const [columnIndex, setColumnIndex] = useState<number | null>(null);
  const user = useSelector(selectUser);

  const [deleteAirticketRefund, { isLoading, isSuccess, isError }] =
    useDeleteAirticketRefundMutation();

  const handleRefundDelete = async (
    values: IAirTicketRefundDataType,
    index: number
  ) => {
    const body: IRefundDeleteRestoreBody = {
      refund_id: values.atrefund_id,
      deleted_by: user?.user_id as number,
    };
    setColumnIndex(index);
    await deleteAirticketRefund(body);
  };

  useEffect(() => {
    if (isSuccess) {
      setColumnIndex(null);
    } else if (isError) {
      setColumnIndex(null);
    }
  }, [isSuccess, isError]);

  return [
    {
      title: 'SL.',
      align: 'center',
      render: (_, data, index) => (
        <>
          {((pagination.current || 1) - 1) * (pagination.pageSize || 20) +
            1 +
            index}
        </>
      ),
    },

    {
      title: 'Refund Date',
      dataIndex: 'atrefund_date',
      key: 'atrefund_date',
      align: 'center',
      render: (_, data) => (
        <>{dayjs(data.atrefund_date).format('DD MMM YYYY')} </>
      ),
    },
    {
      title: 'Voucher No',
      dataIndex: 'atrefund_vouchar_number',
      key: 'atrefund_vouchar_number',
    },
    {
      title: 'Client',
      dataIndex: 'client_name',
      key: 'client_name',
      render: (value, record) => {
        const { atrefund_client_id, atrefund_combined_id } = record;

        return record?.atrefund_combined_id || record?.atrefund_client_id ? (
          <Link
            to={
              atrefund_client_id
                ? `/reports/client_ledger?id=${atrefund_client_id}`
                : `/reports/combined_ledger?id=${atrefund_combined_id}`
            }
          >
            <span>{record.client_name}</span>
          </Link>
        ) : (
          value
        );
      },
    },
    {
      title: 'Refund charge',
      dataIndex: 'crefund_charge_amount',
      key: 'crefund_charge_amount',
      align: 'end',
      render: (crefund_charge_amount) => {
        return <>{Number(crefund_charge_amount) || 0}</>;
      },
    },

    {
      title: 'Refund profit',
      dataIndex: 'crefund_profit',
      key: 'crefund_profit',
      align: 'end',
      render: (crefund_profit) => {
        return <>{Number(crefund_profit) || 0}</>;
      },
    },

    {
      title: 'Type',
      dataIndex: 'crefund_payment_type',
      key: 'crefund_payment_type',
    },
    {
      title: 'Note',
      dataIndex: 'atrefund_note',
      key: 'atrefund_note',
      align: 'justify',
    },

    {
      title: 'Action',
      key: 'operation',
      align: 'left',
      render: (_, record, index) => (
        <Space size='small'>
          {permission?.['read:any'] && !checkButtonState && (
            <Link
              to={`/refund/airticket/details/${record.atrefund_id}`}
              state={location.pathname}
            >
              <Button size='small' type='primary'>
                <Typography style={{ color: '#ffffff' }}>View</Typography>
              </Button>
            </Link>
          )}

          {permission?.['update:any'] && record.is_adjust_rf ? (
            <Button
              size='small'
              type='primary'
              onClick={() =>
                navigate(
                  `/refund/edit-airticket-adjust-refund/${record.atrefund_id}`,
                  { state: '/refund/airticket-new' }
                )
              }
            >
              Edit
            </Button>
          ) : undefined}

          {permission?.['delete:any'] && !checkButtonState && (
            <Popconfirm
              title='Sure to delete?'
              onConfirm={() => handleRefundDelete(record, index)}
            >
              <Button
                size='small'
                type='primary'
                danger
                loading={columnIndex === index && true}
              >
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];
};
